import { Drawer, Menu, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import './top-menu-block.scss';
import { getMenuList } from '/react4xp/parts/service-link-img/actions';

const TopMenuBlock = (props) => {
    const [list, setList] = useState<any[]>();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
    const [drawerVisible, setDrawerVisible] = useState(false);

    const toggleDrawer = () => {
        setDrawerVisible(!drawerVisible);
    };

    useEffect(() => {
        getMenuList(props.context)
            .then((value) => {
                if (value.data) {
                    setList(value.data);
                }
            })
            .finally();

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.contentRect && entry.contentRect.width) {
                    setIsMobile(entry.contentRect.width < 700);
                }
            }
        });

        resizeObserver.observe(document.documentElement);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    const goTo = (path: string) => {
        open('/' + props.language + path.replace('/isna-portal-cms', ''), '_self');
    };

    return (
        <div className="top-menu-block">
            {!list ? (
                <Skeleton
                    active
                    paragraph={{ rows: 1 }}
                    title={false}
                />
            ) : (
                <>
                    {isMobile ? (
                        <>
                            <input
                                id="menu-toggle"
                                type="checkbox"
                                checked={drawerVisible}
                                onChange={toggleDrawer}
                            />
                            <label
                                className="menu-button-container"
                                htmlFor="menu-toggle"
                            >
                                <div className="menu-button" />
                            </label>
                            <Drawer
                                title="Главное меню"
                                placement="right"
                                closable={false}
                                onClose={toggleDrawer}
                                open={drawerVisible}
                                width="70%"
                            >
                                <Menu
                                    mode="vertical"
                                    items={list
                                        .filter((x) => !x.dataAsJson.menu)
                                        .map((x) => ({
                                            key: x.id,
                                            className: 'menu-link',
                                            onClick: () => goTo(x._path),
                                            label: x.displayName,
                                        }))}
                                />
                            </Drawer>
                        </>
                    ) : (
                        <Menu
                            mode="horizontal"
                            items={list
                                .filter((x) => !x.dataAsJson.menu)
                                .map((x) => ({
                                    key: x.id,
                                    className: 'menu-link',
                                    onClick: () => goTo(x._path),
                                    label: x.displayName,
                                }))}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default TopMenuBlock;
